import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Settings, APP_CONFIG } from 'src/app/config/settings';
import { combine } from 'src/app/shared/utilities/route';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RecommendJobService {
    private coreApiPath = '';
    constructor(
        private readonly _httpClient: HttpClient,
        @Inject(APP_CONFIG) settings: Settings
    ) {
        this.coreApiPath = combine(settings.coreAPIUrl, 'ayanova');
    }

    recommendJobsToMultipleCandidates(candidateIds: number[], jobIds: number[]): Observable<boolean> {
        const body = {
            clinicianIds: candidateIds,
            jobIds: jobIds
        };

        return this._httpClient.post<boolean>(`${this.coreApiPath}/candidate/job-recommendations`, body);
    }
}
